export default __webpack_public_path__ + "static/media/light-film.af866c48.png";